<div class="main-section">
  <!-- Begin:: Detail slider -->
  <section class="gamesList">
      <div class="item">
          <!-- src="./../../assets/images/game1.jpg" -->
          <!-- <img (click)="getGameUrl(gameDetails.cdm_url)" style="width: 200px !important;height: 200px !important;" class="svg" src="./../../assets/images/play_blue.png" alt=""> -->
          <!-- <span class="material-icons" style="position: absolute;z-index:99;margin-top: 0.4em;margin-left: 0.4em;font-size: 45px;" color="light">play_circle</span> -->
          <img  [src]="gameDetails.cdm_content_path" class="img-fluid game-banner" alt="game banner">

          <div class="game-detail">
              <div class="d-flex justify-content-between">
                  <h2 class="game-head">{{gameDetails.cdm_title}}</h2>
                  <div class="ratting">
                      <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                      <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                      <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                      <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                      <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid" />
                  </div>
              </div>
              <p class="play-time">97,344,709 play times</p>

              <div class="d-flex justify-content-between justify-content-md-start">
                  <!-- <button class="btn btn-ghost">Add To Favourite</button> -->
                  <!-- <button class="btn btn-ghost">Share (23.7 K)</button> -->
                  <button (click)="getGameUrl(gameDetails.cdm_url)" class="btn btn-ghost" style="color: white !important; background: #7edd1e;">Play</button>
              </div>

              <div class="desc-block">
                  <h4 class="game-subhead mt-40">GAME DETAILS</h4>
                  <p class="detail-desc">Slope is the ultimate running game that will put your skills to the test. Speed down on a randomized slope. The farther you go, the faster your ball travels. This game might look simple but playing this will give you extreme adrenaline
                      rush. Just remember to avoid obstacles and those red blocks. Always be on track to get a high score and you might have your name on the leaderboard!</p>
              </div>

              <div class="comment-block">
                  <h4 class="game-subhead d-flex align-items-center">COMMENTS <span class="total-comment">2889</span></h4>
                  <div class="comment-section">
                      <div class="comment-area">
                          <div class="user-img">
                              <img src="./../../assets/images/prof.png" class="img-fluid" alt="user" />
                          </div>
                          <div class="user-thought">
                              <h6 class="user-name">Eat Bullets</h6>
                              <div class="ratting">
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid" />
                              </div>
                              <p>This is some content from a media component. You can replace this with any content and adjust it as needed.This is some content from a media component. You can replace this with any content and adjust it as needed.</p>
                          </div>
                      </div>
                      <!-- <div class="comment-area">
                          <div class="user-img">
                              <img src="./../../assets/images/prof.png" class="img-fluid" alt="user" />
                          </div>
                          <div class="user-thought">
                              <h6 class="user-name">Eat Bullets</h6>
                              <div class="ratting">
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid" />
                              </div>
                              <p>This is some content from a media component. You can replace this with any content and adjust it as needed.This is some content from a media component. You can replace this with any content and adjust it as needed.</p>
                          </div>
                      </div> -->
                      <!-- <div class="more">
                      <div class="comment-area">
                          <div class="user-img">
                              <img src="./../../assets/images/user.png" class="img-fluid" alt="user" />
                          </div>
                          <div class="user-thought">
                              <h6 class="user-name">Eat Bullets</h6>
                              <div class="ratting">
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid" />
                              </div>
                              <p>This is some content from a media component. You can replace this with any content and adjust it as needed.This is some content from a media component. You can replace this with any content and adjust it as needed.</p>
                          </div>
                      </div>
                      <div class="comment-area">
                          <div class="user-img">
                              <img src="./../../assets/images/user.png" class="img-fluid" alt="user" />
                          </div>
                          <div class="user-thought">
                              <h6 class="user-name">Eat Bullets</h6>
                              <div class="ratting">
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid" />
                              </div>
                              <p>This is some content from a media component. You can replace this with any content and adjust it as needed.This is some content from a media component. You can replace this with any content and adjust it as needed.</p>
                          </div>
                      </div>

                      <div class="comment-area ">
                          <div class="user-img">
                              <img src="./../../assets/images/user.png" class="img-fluid" alt="user" />
                          </div>
                          <div class="user-thought">
                              <h6 class="user-name">Eat Bullets</h6>
                              <div class="ratting">
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid" />
                              </div>
                              <p>This is some content from a media component. You can replace this with any content and adjust it as needed.This is some content from a media component. You can replace this with any content and adjust it as needed.</p>
                          </div>
                      </div>
                  </div> -->

              </div>
              <button class=" btn btn-link more-comment">View More</button>

                  <form>
                      <div class="">
                          <textarea class="form-control" rows="6px" placeholder="What are your thoughts?"></textarea>
                      </div>
                      <div class="clearfix">
                          <div class="add-rating">
                              <input name="stars" id="e5" type="radio"><label for="e5"> <img src="./../../assets/images/star.png" alt="star" class="img-fluid rated" /></label>
                              <input name="stars" id="e4" type="radio"><label for="e4"> <img src="./../../assets/images/star.png" alt="star" class="img-fluid rated" /></label>
                              <input name="stars" id="e3" type="radio"><label for="e3"> <img src="./../../assets/images/star.png" alt="star" class="img-fluid rated" /></label>
                              <input name="stars" id="e2" type="radio"><label for="e2"> <img src="./../../assets/images/star.png" alt="star" class="img-fluid rated" /></label>
                              <input name="stars" id="e1" type="radio"><label for="e1"> <img src="./../../assets/images/star.png" alt="star" class="img-fluid rated" /></label>
                          </div>
                      </div>
                      <div class="text-center">
                          <button class="btn btn-ghost btn-post" disabled>POST</button>
                      </div>
                  </form>
              </div>
          </div>
      </div>
      <!-- <div class="item">
          <img src="./../../assets/images/game2.jpg" class="img-fluid game-banner" alt="game banner">

          <div class="game-detail">
              <div class="d-flex justify-content-between">
                  <h2 class="game-head">PlayerUnknown's Battlegrounds</h2>
                  <div class="ratting">
                      <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                      <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                      <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                      <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                      <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid" />
                  </div>
              </div>
              <p class="play-time">97,344,709 play times</p>

              <div class="d-flex justify-content-between justify-content-md-start">
                  <button class="btn btn-ghost">Add To Favourite</button>
                  <button class="btn btn-ghost">Share (23.7 K)</button>
              </div>

              <div class="desc-block">
                  <h4 class="game-subhead mt-40">GAME DETAILS</h4>
                  <p class="detail-desc">Slope is the ultimate running game that will put your skills to the test. Speed down on a randomized slope. The farther you go, the faster your ball travels. This game might look simple but playing this will give you extreme adrenaline
                      rush. Just remember to avoid obstacles and those red blocks. Always be on track to get a high score and you might have your name on the leaderboard!</p>
              </div>

              <div class="comment-block">
                  <h4 class="game-subhead d-flex align-items-center">COMMENTS <span class="total-comment">2889</span></h4>
                  <div class="comment-section">
                      <div class="comment-area">
                          <div class="user-img">
                              <img src="./../../assets/images/user.png" class="img-fluid" alt="user" />
                          </div>
                          <div class="user-thought">
                              <h6 class="user-name">Eat Bullets</h6>
                              <div class="ratting">
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid" />
                              </div>
                              <p>This is some content from a media component. You can replace this with any content and adjust it as needed.This is some content from a media component. You can replace this with any content and adjust it as needed.</p>
                          </div>
                      </div>
                      <div class="comment-area">
                          <div class="user-img">
                              <img src="./../../assets/images/user.png" class="img-fluid" alt="user" />
                          </div>
                          <div class="user-thought">
                              <h6 class="user-name">Eat Bullets</h6>
                              <div class="ratting">
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid" />
                              </div>
                              <p>This is some content from a media component. You can replace this with any content and adjust it as needed.This is some content from a media component. You can replace this with any content and adjust it as needed.</p>
                          </div>
                      </div>
                      <div class="more">
                      <div class="comment-area">
                          <div class="user-img">
                              <img src="./../../assets/images/user.png" class="img-fluid" alt="user" />
                          </div>
                          <div class="user-thought">
                              <h6 class="user-name">Eat Bullets</h6>
                              <div class="ratting">
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid" />
                              </div>
                              <p>This is some content from a media component. You can replace this with any content and adjust it as needed.This is some content from a media component. You can replace this with any content and adjust it as needed.</p>
                          </div>
                      </div>
                      <div class="comment-area">
                          <div class="user-img">
                              <img src="./../../assets/images/user.png" class="img-fluid" alt="user" />
                          </div>
                          <div class="user-thought">
                              <h6 class="user-name">Eat Bullets</h6>
                              <div class="ratting">
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid" />
                              </div>
                              <p>This is some content from a media component. You can replace this with any content and adjust it as needed.This is some content from a media component. You can replace this with any content and adjust it as needed.</p>
                          </div>
                      </div>

                      <div class="comment-area ">
                          <div class="user-img">
                              <img src="./../../assets/images/user.png" class="img-fluid" alt="user" />
                          </div>
                          <div class="user-thought">
                              <h6 class="user-name">Eat Bullets</h6>
                              <div class="ratting">
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid" />
                              </div>
                              <p>This is some content from a media component. You can replace this with any content and adjust it as needed.This is some content from a media component. You can replace this with any content and adjust it as needed.</p>
                          </div>
                      </div>
                  </div>

              </div>
              <button class=" btn btn-link more-comment">View More</button>

                  <form>
                      <div class="">
                          <textarea class="form-control" rows="6px" placeholder="What are your thoughts?"></textarea>
                      </div>
                      <div class="clearfix">
                          <div class="add-rating">
                              <input name="stars" id="e5" type="radio"><label for="e5"> <img src="./../../assets/images/star.png" alt="star" class="img-fluid rated" /></label>
                              <input name="stars" id="e4" type="radio"><label for="e4"> <img src="./../../assets/images/star.png" alt="star" class="img-fluid rated" /></label>
                              <input name="stars" id="e3" type="radio"><label for="e3"> <img src="./../../assets/images/star.png" alt="star" class="img-fluid rated" /></label>
                              <input name="stars" id="e2" type="radio"><label for="e2"> <img src="./../../assets/images/star.png" alt="star" class="img-fluid rated" /></label>
                              <input name="stars" id="e1" type="radio"><label for="e1"> <img src="./../../assets/images/star.png" alt="star" class="img-fluid rated" /></label>
                          </div>
                      </div>
                      <div class="text-center">
                          <button class="btn btn-ghost btn-post">POST</button>
                      </div>
                  </form>
              </div>
          </div>
      </div>

      <div class="item">
          <img src="./../../assets/images/game3.jpg" class="img-fluid game-banner" alt="game banner">

          <div class="game-detail">
              <div class="d-flex justify-content-between">
                  <h2 class="game-head">Free Fire</h2>
                  <div class="ratting">
                      <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                      <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                      <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                      <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                      <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid" />
                  </div>
              </div>
              <p class="play-time">97,344,709 play times</p>

              <div class="d-flex justify-content-between justify-content-md-start">
                  <button class="btn btn-ghost">Add To Favourite</button>
                  <button class="btn btn-ghost">Share (23.7 K)</button>
              </div>

              <div class="desc-block">
                  <h4 class="game-subhead mt-40">GAME DETAILS</h4>
                  <p class="detail-desc">Slope is the ultimate running game that will put your skills to the test. Speed down on a randomized slope. The farther you go, the faster your ball travels. This game might look simple but playing this will give you extreme adrenaline
                      rush. Just remember to avoid obstacles and those red blocks. Always be on track to get a high score and you might have your name on the leaderboard!</p>
              </div>

              <div class="comment-block">
                  <h4 class="game-subhead d-flex align-items-center">COMMENTS <span class="total-comment">2889</span></h4>
                  <div class="comment-section">
                      <div class="comment-area">
                          <div class="user-img">
                              <img src="./../../assets/images/user.png" class="img-fluid" alt="user" />
                          </div>
                          <div class="user-thought">
                              <h6 class="user-name">Eat Bullets</h6>
                              <div class="ratting">
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid" />
                              </div>
                              <p>This is some content from a media component. You can replace this with any content and adjust it as needed.This is some content from a media component. You can replace this with any content and adjust it as needed.</p>
                          </div>
                      </div>
                      <div class="comment-area">
                          <div class="user-img">
                              <img src="./../../assets/images/user.png" class="img-fluid" alt="user" />
                          </div>
                          <div class="user-thought">
                              <h6 class="user-name">Eat Bullets</h6>
                              <div class="ratting">
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid" />
                              </div>
                              <p>This is some content from a media component. You can replace this with any content and adjust it as needed.This is some content from a media component. You can replace this with any content and adjust it as needed.</p>
                          </div>
                      </div>
                      <div class="more">
                      <div class="comment-area">
                          <div class="user-img">
                              <img src="./../../assets/images/user.png" class="img-fluid" alt="user" />
                          </div>
                          <div class="user-thought">
                              <h6 class="user-name">Eat Bullets</h6>
                              <div class="ratting">
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid" />
                              </div>
                              <p>This is some content from a media component. You can replace this with any content and adjust it as needed.This is some content from a media component. You can replace this with any content and adjust it as needed.</p>
                          </div>
                      </div>
                      <div class="comment-area">
                          <div class="user-img">
                              <img src="./../../assets/images/user.png" class="img-fluid" alt="user" />
                          </div>
                          <div class="user-thought">
                              <h6 class="user-name">Eat Bullets</h6>
                              <div class="ratting">
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid" />
                              </div>
                              <p>This is some content from a media component. You can replace this with any content and adjust it as needed.This is some content from a media component. You can replace this with any content and adjust it as needed.</p>
                          </div>
                      </div>

                      <div class="comment-area ">
                          <div class="user-img">
                              <img src="./../../assets/images/user.png" class="img-fluid" alt="user" />
                          </div>
                          <div class="user-thought">
                              <h6 class="user-name">Eat Bullets</h6>
                              <div class="ratting">
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid rated" />
                                  <img src="./../../assets/images/Icon-star.png" alt="star" class="img-fluid" />
                              </div>
                              <p>This is some content from a media component. You can replace this with any content and adjust it as needed.This is some content from a media component. You can replace this with any content and adjust it as needed.</p>
                          </div>
                      </div>
                  </div>

              </div>
              <button class=" btn btn-link more-comment">View More</button>

                  <form>
                      <div class="">
                          <textarea class="form-control" rows="6px" placeholder="What are your thoughts?"></textarea>
                      </div>
                      <div class="clearfix">
                          <div class="add-rating">
                              <input name="stars" id="e5" type="radio"><label for="e5"> <img src="./../../assets/images/star.png" alt="star" class="img-fluid rated" /></label>
                              <input name="stars" id="e4" type="radio"><label for="e4"> <img src="./../../assets/images/star.png" alt="star" class="img-fluid rated" /></label>
                              <input name="stars" id="e3" type="radio"><label for="e3"> <img src="./../../assets/images/star.png" alt="star" class="img-fluid rated" /></label>
                              <input name="stars" id="e2" type="radio"><label for="e2"> <img src="./../../assets/images/star.png" alt="star" class="img-fluid rated" /></label>
                              <input name="stars" id="e1" type="radio"><label for="e1"> <img src="./../../assets/images/star.png" alt="star" class="img-fluid rated" /></label>
                          </div>
                      </div>
                      <div class="text-center">
                          <button class="btn btn-ghost btn-post">POST</button>
                      </div>
                  </form>
              </div>
          </div>
      </div> -->
  </section>
  <!-- End:: Detail slider -->


  <section class="mt-35">
      <div class="container">
          <div class="row">
              <div class="col-12 d-flex justify-content-between">
                  <h3 class="section-heading"><span class="text-theme-green">RELATED GAMES</span></h3>

              </div>
              <div class="col-6 col-xl-3 col-md-4" *ngFor="let item of trendingList" >
                  <div class="custom-card">
                      <div class="card-img">
                          <img (click)="gotoHome(item)" [src]="item.cdm_content_path" alt="card1" style="cursor: pointer;">
                      </div>
                      <div class="card-text">
                          <div class="star-rating">
                              <img src="././../../assets/images/Icon-star.png" alt="">
                              <span>4.2</span>
                          </div>
                          <p class="total-ratings">33,890</p>
                      </div>
                  </div>
              </div>
              <!-- <div class="col-6 col-xl-3 col-md-4">
                  <div class="custom-card">
                      <div class="card-img">
                          <img src="././../../assets/images/img-1.png" alt="card1">
                      </div>
                      <div class="card-text">
                          <div class="star-rating">
                              <img src="././../../assets/images/Icon-star.png" alt="">
                              <span>4.2</span>
                          </div>
                          <p class="total-ratings">33,890</p>
                      </div>
                  </div>
              </div>
              <div class="col-6 col-xl-3 col-md-4">
                  <div class="custom-card">
                      <div class="card-img">
                          <img src="././../../assets/images/img-1.png" alt="card1">
                      </div>
                      <div class="card-text">
                          <div class="star-rating">
                              <img src="././../../assets/images/Icon-star.png" alt="">
                              <span>4.2</span>
                          </div>
                          <p class="total-ratings">33,890</p>
                      </div>
                  </div>
              </div>
              <div class="col-6 col-xl-3 col-md-4 d-md-none d-xl-block">
                  <div class="custom-card">
                      <div class="card-img">
                          <img src="././../../assets/images/img-1.png" alt="card1">
                      </div>
                      <div class="card-text">
                          <div class="star-rating">
                              <img src="././../../assets/images/Icon-star.png" alt="">
                              <span>4.2</span>
                          </div>
                          <p class="total-ratings">33,890</p>
                      </div>
                  </div>
              </div> -->
          </div>
      </div>
  </section>

</div>
